<template lang="pug">
.inside-padding
  form(@submit.prevent="")
    h3.capitalize Invoices Report

    sh-date-range-select(default-range="thisMonth" @change="onDateRangeChange" @display-change="onDisplayChange")
    .container-actions
      shActionButton(:isForm="true" :action="generateReport" text="Generar Reporte" textRunning="Generando Reporte")

  .container-report
    p.report-meta Fecha: {{ display }}

    h3.capitalize Facturas
    table.stock-table
      tbody
        tr
          td Cantidad
          td {{ totalInvoices.facturas.count }}
        tr
          td Base
          td {{ money(totalInvoices.facturas.base) }}
        tr
          td IVA
          td {{ money(totalInvoices.facturas.tax) }}
        tr
          td Total
          td {{ money(totalInvoices.facturas.value) }}

    h3.capitalize Notas Crédito
    table.stock-table
      tbody
        tr
          td Cantidad
          td {{ totalInvoices.notasCredito.count }}
        tr
          td Base
          td {{ money(totalInvoices.notasCredito.base) }}
        tr
          td IVA
          td {{ money(totalInvoices.notasCredito.tax) }}
        tr
          td Total
          td {{ money(totalInvoices.notasCredito.value) }}

    h3.capitalize Balance
    table.stock-table
      tbody
        tr
          td Cantidad
          td {{ totalInvoices.facturas.count + totalInvoices.notasCredito.count }}
        tr
          td Base
          td {{ money(totalInvoices.facturas.base - totalInvoices.notasCredito.base) }}
        tr
          td IVA
          td {{ money(totalInvoices.facturas.tax - totalInvoices.notasCredito.tax) }}
        tr
          td Total
          td {{ money(totalInvoices.facturas.value - totalInvoices.notasCredito.value) }}
</template>

<script>
import mFilters from '@/mixins/filters'
import mForm from '@/mixins/form'
import shNameUser from '@/components/elements/NameUser'
import shDateRangeSelect from '@/components/helpers/DateRangeSelect'

export default {
  name: 'ReportInvoices',

  mixins: [mFilters, mForm],
  components: { shNameUser, shDateRangeSelect },

  data () {
    return {
      init: '',
      final: '',
      totalInvoices: {
        facturas: { count: 0, base: 0, tax: 0, value: 0 },
        notasCredito: { count: 0, base: 0, tax: 0, value: 0 }
      },
      display: ''
    }
  },

  methods: {
    onDisplayChange (display) {
      this.display = display
    },
    onDateRangeChange ({ init, final }) {
      this.init = init
      this.final = final
    },
    async generateReport () {
      this.$store.commit('setInitialDateReport', { report: 'invoices', date: this.init })
      this.$store.commit('setFinalDateReport', { report: 'invoices', date: this.final })

      await this.$store.dispatch('getDataInvoices')
      this.getTotalInvoices()
    },
    getTotalInvoices () {
      this.totalInvoices.facturas = { count: 0, base: 0, tax: 0, value: 0 }
      this.totalInvoices.notasCredito = { count: 0, base: 0, tax: 0, value: 0 }
      this.reportInvoices.docs.forEach(invoice => {
        if (invoice.type === 'Factura') {
          this.totalInvoices.facturas.count++
          this.totalInvoices.facturas.tax += invoice.tax
          this.totalInvoices.facturas.value += invoice.value
          this.totalInvoices.facturas.base += (invoice.value - invoice.tax)
        } else if (invoice.type === 'Nota Credito') {
          this.totalInvoices.notasCredito.count++
          this.totalInvoices.notasCredito.tax += invoice.tax
          this.totalInvoices.notasCredito.value += invoice.value
          this.totalInvoices.notasCredito.base += (invoice.value - invoice.tax)
        } else {
          console.log(invoice.type, 'invoice.type')
          throw new Error('Tipo de factura no válido')
        }
      })
    }
  },

  computed: {
    reportInvoices () {
      return this.$store.state.reports.invoices
    }
  }
}
</script>

<style lang="stylus">
.container-report
  text-align left
  padding 0 1em

.container-report h3
  font-size 1.3rem
  font-weight 600
  margin 1.5em 0 1.2em 0

.report-meta
  margin .2em 0
  font-size .9em
  color rgba(0, 0, 0, .6)

.stock-table
  width 100%
  border-collapse collapse

  td
    padding 1rem .5rem
    border-top 1px solid rgba(0, 0, 0, .2)
    text-align left

  td:first-child
    width 260px

  td:last-child
    opacity .7

.container-actions
  margin-top 1em
  display flex
  justify-content center
  gap 1em
</style>



// WEBPACK FOOTER //
// src/components/pages/reports/Invoices.vue